import React, { useState, useRef } from "react";
import { useForm } from "react-hook-form";
import axios from "../../helpers/axios";
import "simplebar/dist/simplebar.min.css";
import { Link } from "react-router-dom";

const ForgotPassword = () => {
  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm({ mode: "onBlur" });
  const errRef = useRef();
  const [errMsg, setErrMsg] = useState([]);
  const [loader, setLoader] = useState(false);
  const [doneButton, setDoneButton] = useState(false);

  const onSubmit = async (data) => {
    setLoader(true);
    setErrMsg("");
    const email = data.user_name;
    const response = await axios
      .post("auth/forgot-password", {
        email: email,
      })
      .then((res) => res)
      .catch((err) => err)
      .finally(() => {
        setLoader(false);
      });
    if (response?.data?.status) {
      setDoneButton(true);
    } else if (Number(response?.response?.status) === 504) {
      setErrMsg("No Server Response!");
    } else {
      setErrMsg(
        response?.data?.message ||
          response?.response?.data?.message ||
          "Failed to send password reset link"
      );
    }
  };

  return (
    <div className="flex items-center justify-center h-screen">
      <main className="lg:flex items-start overflow-hidden pt-[77px] -mt-[77px]">
        <div className="flex-1 justify-center set-middle w-[380px]">
          <div className="mb-6 text-center">
            <div>
              <img
                src="/images/logo-large.svg"
                className="inline-block mb-6 w-20 h-20"
                alt=""
              />
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-2">
              Forgot password ?
            </h2>
            <p>No worries, we'll send you reset instructions</p>
          </div>
          <form onSubmit={handleSubmit(onSubmit)}>
            <span
              className="flex items-center font-medium tracking-wide text-red-500 text-sm mt-1"
              ref={errRef}
            >
              {errMsg}
            </span>
            <div className=" mb-4">
              <label htmlFor="">Email</label>
              <input
                type="text"
                {...register("user_name", {
                  required: "Please enter your registered email adress",
                  pattern: {
                    value:
                      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                    message: "Please enter a valid email",
                  },
                })}
              />

              {errors?.user_name && (
                <span className="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
                  {errors.user_name.message}
                </span>
              )}
            </div>

            <div className=" mb-4">
              {doneButton ? (
                <button className="btn btn--full text-[14px]" disabled>
                  <svg
                    className="w-6 h-6 dark:text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                  </svg>
                  Done
                </button>
              ) : loader ? (
                <div role="status">
                  <button className="btn btn--full text-[14px]" disabled>
                    <svg
                      aria-hidden="true"
                      className="mr-2 w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
                      viewBox="0 0 100 101"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                        fill="currentColor"
                      />
                      <path
                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                        fill="currentFill"
                      />
                    </svg>
                    Sending password reset link
                  </button>
                  <span className="sr-only">Loading...</span>
                </div>
              ) : (
                <input
                  type="submit"
                  className="btn btn--full text-[14px]"
                  value="Send password reset link "
                />
              )}
            </div>
            <div className=" mb-4">
              <Link to="/" className="btn btn--full btn--border">
                Back to Login
              </Link>
            </div>
            {doneButton ? (
              <div className=" mb-4 ">
                <div
                  className="bg-teal-100 border-t-4 border-teal-500 rounded-b text-teal-900 px-4 py-3 shadow-md"
                  role="alert"
                >
                  <div className="flex">
                    <div className="py-1">
                      <svg
                        className="fill-current h-6 w-6 text-teal-500 mr-4"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                      >
                        <path d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM9 11V9h2v6H9v-4zm0-6h2v2H9V5z" />
                      </svg>
                    </div>
                    <div>
                      <p className="font-bold">
                        Password reset link <br />
                        has been successfully sent to your email.
                      </p>
                    
                      <p className="text-sm">
                        Please check your registered email to change or reset
                        your password
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}
          </form>
        </div>
      </main>
    </div>
  );
};

export default ForgotPassword;
